var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('img',{staticClass:"overlay-loader",attrs:{"src":_vm.spinnerUrl,"alt":"Loading Spinner"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }